import {Directive, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {AppService} from "@irb/app.service";
import {IEvent, IEventSubscriber, IrbEditorsEvents} from "@irb-common/events";
import {Subscription} from "rxjs";
import {ServiceLocator} from "@irb-common/services/locator.service";
import {UtilityService} from '@irb-common/services/utility.service';

export interface EditorsComponent<T> {
  _data: T;
  change: EventEmitter<boolean>;
}

@Directive()
export class IrbEditorComponent implements EditorsComponent<any>, IEventSubscriber, OnDestroy, OnInit {
    originalData: any;
    @Output() change = new EventEmitter<boolean>();
    eventSubscription: Subscription;
    protected as: AppService;
    protected util: UtilityService;

    constructor() {
        this.as = ServiceLocator.injector.get(AppService);
        this.util = ServiceLocator.injector.get(UtilityService);

        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
    }

    _data: any;

    @Input()
    get data(): any {
        return this._data;
    }

    set data(d: any) {
        this._data = d;
    }

    ngOnInit() {
        this.onDataLoad();
    }

    ngOnDestroy() {
        this.eventSubscription.unsubscribe();
    }

    processEvent(event: IEvent): void {
        switch (event.type) {
            case IrbEditorsEvents.DATA_CHANGED:
                this.onDataChange();
                break;
            case IrbEditorsEvents.DATA_LOADED:
                this.onDataLoad();
                break;
        }
    }

    onDataChange() {
    }

    onDataLoad() {
        this.originalData = this.util.clone(this.data);
    }
}
